import translateFieldsInArray from "./translateFieldsInArray";

const translateLabels = (arr) => translateFieldsInArray(arr, ["label"]);

export default translateLabels;
